import { render, staticRenderFns } from "./P0926.vue?vue&type=template&id=39560274&"
import script from "./P0926.vue?vue&type=script&lang=ts&"
export * from "./P0926.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports